import React from 'react'
import locale from 'parent/i18n/react'
import {Link} from 'react-router-dom'
import Constants from 'scripts/base/Constants'

class Feedback extends React.Component {
  constructor(props) {
    super(props)
    this.lang = locale.getLanguage() || Constants.DefaultLang
  }

  render () {
    const prefixPath = this.lang !== Constants.DefaultLang ? `/${this.lang}` : ''
    return (
      <div className="component-feedback">
        <Link to={`${prefixPath}/submit-tip`} title={locale.buttons.submitTipTitle}>{locale.buttons.submitTip}</Link>
      </div>
    )
  }
}

export default Feedback



// WEBPACK FOOTER //
// ./assets/js/components/static/feedback.jsx